import { useDebounceCallback } from "usehooks-ts";
import useGet from "../useGet";

const useGetBusinessAccountApplications = () => {
  const { data, setParamsObject, paramsObject } = useGet({
    url: "business/list",
    initialParams: {
      pageNo: 0,
      limit: 10,
      searchQuery: "",
    },
  });
  const applicationList = data?.data?.data || [];
  const pagination = {
    total_count: data?.data?.total_count || 0,
    per_page: data?.data?.per_page || 10,
    page_no: paramsObject?.pageNo || 0,
  };
  
  const isLoading = data?.isLoading || false;
  const status = data?.status || null;
  const error = data?.error || null;

  const debouncedSearch = useDebounceCallback((searchQuery) => {
    setParamsObject((prev) => {
      return {
        ...prev,
        searchQuery: searchQuery,
        pageNo: 0,
      };
    });
  }, 750);

  const handlePageClick = (val) => {
    setParamsObject((prev) => {
      return {
        ...prev,
        pageNo: val.selected,
      };
    });
  };

  return {
    applicationList,
    isLoading,
    status,
    error,
    pagination,
    handlePageClick,
    debouncedSearch,
  };
};

export default useGetBusinessAccountApplications;
